// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const ResponsiveImage = require('client-v2/common/components/responsive-image')
const UserAvatar = require('client-v2/common/components/user-avatar')
const { registerEventHandlerShim } = require('client-v2/common/components/utils')
const { userProfileHref } = require('client-v2/common/models/user/actions')
// Container imports
const CollectionModelRecord = require('../collection/record')

const bem = BemEntity('CollectionProfileHeader')

class CollectionProfileHeader extends React.PureComponent {
  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    registerEventHandlerShim(this, 'onUserClick')
  }

  renderBanner() {
    const { collection } = this.props
    return tag(ResponsiveImage, {
      className: bem.element('banner'),
      imageUrls: collection['header_image_urls']
    })
  }

  renderCaption() {
    const { visibility } = this.props.collection
    const isPrivate = visibility === CollectionModelRecord.VISIBILITY_PRIVATE
    return tag('div', {
      className: bem.element('caption', { private: isPrivate })
    },
      isPrivate && 'Private ',
      'Collection'
    )
  }

  renderDescription() {
    const { description } = this.props.collection
    return tag('div', {
      className: bem.element('description')
    },
      // If not set, don't render a text node so that :empty applies
      description || null
    )
  }

  renderDetails() {
    return tag('div', {
      className: bem.element('details')
    },
      this.renderCaption(),
      this.renderName(),
      this.renderDescription()
    )
  }

  renderName() {
    return tag('div', {
      className: bem.element('name')
    },
      this.props.collection.name
    )
  }

  renderUser() {
    return tag('a', {
      className: bem.element('user-href'),
      href: userProfileHref(this.props.collection),
      onClick: this.onUserClick
    },
      tag(UserAvatar, {
        className: bem.element('user-avatar'),
        user: this.props.collection,
        visible: true
      }),
      `by @${this.props.collection.username}`
    )
  }

  render() {
    return tag('div', {
      className: classNames(
        this.props.className,
        bem.block()
      )
    },
      this.renderBanner(),
      this.renderDetails(),
      this.renderUser()
    )
  }
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  CollectionProfileHeader.propTypes = {
    // Values
    className: PropTypes.string,
    collection: PropTypes.shape(CollectionModelRecord.propTypes).isRequired,
    // Callbacks
    onUserClick: PropTypes.func
  }
}

module.exports = CollectionProfileHeader
